import { GraphQLClient } from 'graphql-request'

import { getSdk, Sdk } from './graphql'

let sdk: Sdk | null = null

const getGraphqlForClient = () => {
  const url = process.env.GRAPHQL_WIDGET_URL
  if (!url) {
    throw new Error('GRAPHQL_WIDGET_URL environment variable is not set')
  }

  if (!sdk) {
    sdk = getSdk(new GraphQLClient(url))
  }
  return sdk
}

export default getGraphqlForClient
